import { EnderecoParmDTO } from "./address";
import { BaseFiltroPagDTO } from "./base-dto";

export class EnderecoEntregaFiltroParmDTO extends BaseFiltroPagDTO {
  idUnidade: number;
  descricao: string;
  endereco: EnderecoParmDTO;
  bloqueado: boolean;
  comPaciente: boolean;
  diasSemUso: number;

  logradouro: string;
  numero: string;
  bairro: string;
  municipio: string;
  estado: string;
}

export class BloqueioDesbloqueioParmDTO {
  ids: string;
  codigos: string;
  idUnidade: number;
  justificativa: string;
}